import { BaseService } from '@/modules/Core/services/BaseService'
import type { IAlertAutomatizaciones } from '@/modules/Administracion/interfaces'
// import type { AxiosResponse } from 'axios'
// import type { IResponseApi } from '@/modules/Core/interfaces'

export class AlertAutomatizacionesService extends BaseService<IAlertAutomatizaciones> {
  constructor () {
    super({
      baseUrl: 'scheduling/alerts/automatizaciones/'
    })
  }
}